export default __webpack_public_path__ + "e70f2224585ea467600fa7afa4115485.png";